<button
  type="button"
  class="favorite-toggle"
  [class.is-small]="small"
  [class.is-pinned]="pinned"
  [disabled]="disabled"
  [attr.aria-pressed]="pinned"
  [attr.aria-label]="label"
  [pTooltip]="small ? null : label"
  tooltipPosition="bottom"
  [title]="small ? label : null"
  (click)="toggle($event)">
  <i class="pi" [ngClass]="pinned ? 'pi-star-fill' : 'pi-star'"></i>
</button>
